import { Component } from 'react';
import axios from 'axios';
import { Breadcrumb, Heading } from '../../common/atoms';
import { Tabbar } from '../../tailwind/molecules';
import OverAllSection from './OverAllSection';
import { utilizationApi } from '../../../services';
import { CoverageManager } from '../../../managers/DoctorConsultationManager';
import { RatingsManager, ContractsManager, UtilizationGraphManager } from '../../../managers';
import { handleAppError } from '../../handlers';
import { UtilizationLockScreen, NoUtilizationCard } from '../../common/organisms';
import { DoctorConsultationLocked, DoctorConsultationLow } from '../../../assets/images';
import { DOCTOR_CONSULTATION_LOCK_CONTENT, FILTER } from '../../../constants/utilization';
import {DoctorConsultation} from '../../common/templates/Utilization';
import moment from 'moment';
import DateRangePicker from '../../tailwind/molecules/DateRangePicker';
import MetricManager from '../../../managers/HealthChecksManager/MetricManager';
import { SALES_ROLE } from '../../../constants/overview';
import { dsButtonPrimary, joinButtonClasses } from '../../../utils/buttonStyles';
let token = '';

class DoctorConsultationPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      metricObj: {},
      usersObj: {},
      ratingObj: {},
      coverageObj: {},
      utilizationObj: {},
      loading: true,
      show_no_utilization: false,
      filterDates: {startDate: null, endDate: null}
    };
  }

  fetchCompleteData = (contractId, startDate, endDate) => {
    token = axios.CancelToken.source();
    this.setState({loading: true })
    let start_date = startDate ? startDate : this.state.selectedContractObj.start_date
    let end_date = endDate ? endDate : this.state.selectedContractObj.end_date
    start_date =  moment(start_date).format('YYYY-MM-DD')
    end_date =  moment(end_date).format('YYYY-MM-DD')

    var promise1 = utilizationApi.doctorFetchMetrics({ contractId: contractId, startDate: start_date, endDate: end_date, cancelToken: token.token });
    // var promise2 = utilizationApi.doctorFetchUsers({ contractId: contractId, startDate: start_date, endDate: end_date, cancelToken: token.token });
    var promise3 = utilizationApi.doctorFetchRatings({ contractId: contractId, startDate: start_date, endDate: end_date, cancelToken: token.token });
    // var promise4 = utilizationApi.doctorFetchCoverage({ contractId: contractId, startDate: start_date, endDate: end_date, cancelToken: token.token });
    var promise5 = utilizationApi.doctorFetchUtilization({ contractId: contractId, startDate: start_date, endDate: end_date, cancelToken: token.token, filter: 'department' });


    Promise.all([promise1, promise3, promise5])
      .then((values) => {
        var resp_arr = values.map((resp) => resp.data);
        var metricObj = new MetricManager({...resp_arr[0],...{benefit_name: 'consultation'}});
        var ratingObj = new RatingsManager(resp_arr[1]);
        var utilizationObj = new UtilizationGraphManager(resp_arr[2], 'department')
        utilizationObj.xAxesLabel = 'Departments';
        var showNoUtilization = metricObj.totalHealthChecksCompleted < 1;
        this.setState({ metricObj, ratingObj, loading: false, show_no_utilization: showNoUtilization, utilizationObj: utilizationObj });
      })
      .catch((err) => handleAppError(err));
  };

  fetchContractDetails = () => {
    const contractId = parseInt(this.props.location.state?.contractId, 10)

    utilizationApi.fetchContracts(
      {},
      (resp) => {
        const contractObj = new ContractsManager(resp.data, 'DOCTOR_CONSULTATION');
        const formattedData = contractObj.formattedData
        const selectedContractObj =  formattedData.find(e => e.contract_id === contractId) ?? formattedData[0]
        this.setState({
          contracts: formattedData,
          selectedContractObj: selectedContractObj,
          contractId: selectedContractObj.contract_id,
          overallId: formattedData[0].contract_id,
          filterDates: { startDate: selectedContractObj?.start_date, endDate: selectedContractObj?.end_date }
        });
      },
      (err) => handleAppError(err)
    );
  };

  componentDidMount() {
    this.fetchContractDetails();
  }

  componentWillUnmount() {
    token && token.cancel();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if ((this.state.contractId && prevState.contractId !== this.state.contractId) || (this.state.filterDates.startDate && prevState.filterDates.startDate !== this.state.filterDates.startDate) || (this.state.filterDates.endDate && prevState.filterDates.endDate !== this.state.filterDates.endDate)) {
      token && token.cancel();
      this.fetchCompleteData(this.state.contractId, this.state.filterDates.startDate, this.state.filterDates.endDate);
    }
  }

  toggleHelp = () => this.props.toggleHelp('Doctor_consultation');

  content = (selectedContractObj) => {
    const { show_no_utilization, loading, overallId } = this.state;

    if (loading || selectedContractObj.enable_doctor_consultations) {
      return show_no_utilization ? (
        <NoUtilizationCard
          line='overall utilization of the doctor consultation'
          imgsrc={DoctorConsultationLow}
          toggleHelp={this.toggleHelp}
          classes='mt-8'
        />
      ) : (
        <DoctorConsultation {...this.state} selectedContractObj={selectedContractObj} sqaureTabHandler={(type) => this.getUtilizationBarData(FILTER[type])}  />
      );
    } else if (selectedContractObj.is_overall_contract) {
      token && token.cancel();
      token = axios.CancelToken.source();
      return <OverAllSection contractId={overallId} token={token} />;
    } else {
      return (
        <div className='mt-8'>
          <UtilizationLockScreen
            sectionTitle='Doctor Consultation is not enabled'
            image={DoctorConsultationLocked}
            sectionSubtitle='Benefits to your employees'
            points={DOCTOR_CONSULTATION_LOCK_CONTENT}
            toggleHelp={this.toggleHelp}
          />
        </div>
      );
    }
  };

  getUtilizationBarData = ({ filter, xAxesLabel }) => {
    const contractId = this.state.contractId;
    let {startDate, endDate} = this.state.filterDates
    let start_date = startDate ? startDate : this.state.selectedContractObj.start_date
    let end_date = endDate ? endDate : this.state.selectedContractObj.end_date
    start_date =  moment(start_date).format('YYYY-MM-DD')
    end_date =  moment(end_date).format('YYYY-MM-DD')
    let utilizationObj = { barlabels: [], bardata: [], barBgColors: [], xAxesLabel: xAxesLabel };
    utilizationApi.doctorFetchUtilization(
      { filter: filter, contractId, startDate: start_date, endDate: end_date },
      (resp) => {
        utilizationObj = new UtilizationGraphManager(resp.data, filter);
        utilizationObj.xAxesLabel = xAxesLabel;
        this.setState({ utilizationObj });
      },
      (err) => {
        this.setState({ utilizationObj });
        handleAppError(err);
      }
    );
  };

  changeContractId = (contractId) => {
    contractId = parseInt(contractId, 10)
    const { contracts = [], selectedContractObj } = this.state
    const newContract = contracts.find(e => e.contract_id === contractId)
    const { contract_id: oldContractId } = selectedContractObj

    if (contractId && oldContractId !== contractId) {
      this.setState({
        contractId: contractId,
        selectedContractObj: newContract,
        metricObj: {},
        usersObj: {},
        ratingObj: {},
        coverageObj: {},
        loading: true,
        show_no_utilization: false,
        filterDates: {startDate: newContract?.start_date, endDate: newContract?.end_date}
      });
    } else {
      this.setState({
        contractId: contractId,
        selectedContractObj: contracts.find(e => e.is_overall_contract),
        loading: false,
        show_no_utilization: false,
        filterDates: {startDate: newContract?.start_date, endDate: newContract?.end_date}
      });
    }
  };

  changeDates = (e, date_type) =>{
    let date = moment(e).format('YYYY-MM-DD')
    if (e){
      if (date_type === 'startDate'){
        this.setState({filterDates: {...this.state.filterDates, startDate: date}})
      }
      else if(date_type === 'endDate') {
        this.setState({filterDates: {...this.state.filterDates, endDate: date}})
      }
      else if(date_type === 'reset'){
        this.setState({filterDates: {startDate: moment(this.state.selectedContractObj?.start_date)}, endDate: moment(this.state.selectedContractObj?.end_date)})
      }
    }
    else{
      if (date_type === 'startDate'){
        this.setState({filterDates: {...this.state.filterDates, startDate: moment(this.state.selectedContractObj.start_date).format('YYYY-MM-DD')}})
      }
      else {
        this.setState({filterDates: {...this.state.filterDates, endDate: moment(this.state.selectedContractObj.end_date).format('YYYY-MM-DD')}})
      }
    }
  };
  
  navigateToActivityLog = () => {
    const { start_date, end_date, contract_id } = this.state.selectedContractObj
    this.props.history.push(`/activity-log?point=consultation`, { start_date, end_date, contract_id });
  };

  render() {
    const { contracts = [], selectedContractObj } = this.state;
    const tabbarList = contracts.map(e => e.text)
    const tabbarIds = contracts.map(e => e.contract_id ?? 'overall-id')

    return (
      <div className='min-w-0'>
        <div className='flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between'>
          <div className='min-w-0'>
            <Breadcrumb
              list={[
                { text: 'Utilization', link: '/utilization/ahc' },
                { text: 'Doctor Consultation', link: '/doctor-consultation' },
              ]}
              classes='mb-1'
            />
            {typeof this.state.selectedContractObj !== 'undefined' && (
              <Heading
                mainHeading='Utilization of Doctor Consultation'
                mainClasses='font-fig-extrabold text-3xl font-medium leading-tight tracking-tight text-gray-900 sm:text-4xl'
              />
            )}
          </div>
          <div className='flex shrink-0 flex-wrap gap-2 lg:justify-end'>
            <button
              type='button'
              onClick={this.navigateToActivityLog}
              disabled={this.state.loading || SALES_ROLE === 'sales' }
              className={joinButtonClasses(dsButtonPrimary, 'h-10 px-5', SALES_ROLE === 'sales' && 'cursor-not-allowed')}
            >
              Activity Log
            </button>
          </div>
        </div>
        <div className='mt-6 flex justify-start'>
          <div className='text-xs font-semibold uppercase tracking-wider text-gray-500'>Contract period / year</div>
        </div>
        <div className='mt-3'>
          <Tabbar
            list={tabbarList}
            ids={tabbarIds}
            loading={!selectedContractObj}
            newPageId={selectedContractObj ? (selectedContractObj.contract_id ?? 'overall-id') : ''}
            changeHandler={this.changeContractId}
          />
        </div>
        {selectedContractObj && (
          <div className='mt-3'>
            <DateRangePicker
              isCurrent={selectedContractObj?.is_running_contract}
              isOverAll={selectedContractObj?.is_overall_contract}
              filterDates={this.state.filterDates}
              contractDates={[this.state.selectedContractObj?.start_date, this.state.selectedContractObj?.end_date]}
              changeDates={this.changeDates}
            />
          </div>
        )}
        {this.content(this.state.selectedContractObj)}
      </div>
    );
  }
}

export default DoctorConsultationPage;
